(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-countdown"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wc-countdown]').forEach((section) => {
    const end = Date.parse(section.dataset.end);
    if (Number.isNaN(end)) return;
    const fields = ['days', 'hours', 'minutes', 'seconds'];
    const update = () => {
      const remaining = Math.max(0, end - Date.now());
      const values = [Math.floor(remaining / 86400000), Math.floor(remaining / 3600000) % 24, Math.floor(remaining / 60000) % 60, Math.floor(remaining / 1000) % 60];
      fields.forEach((field, index) => { section.querySelector(`[data-${field}]`).textContent = String(values[index]).padStart(2, '0'); });
    };
    update();
    window.setInterval(update, 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
